export { default as CoverDetails } from './CoverDetails';
